import React,{useRef} from 'react';
import SideBarc from './SideBarc';
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import ComprarToken from './ComprarToken';
import '../home.css';

import {Protegerotas} from './protegerotas';
import { useHistory } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
function RHome() {
  const ileTimeRed=useRef(null)
  const history = useHistory();
  const onIdle=()=>{
    localStorage.setItem('log',false)
    history.push('/');
  }
    return (
     
        <Router>
           <SideBarc/ >
        <div className="Home">            
      
        <IdleTimer ref={ileTimeRed} timeout={60*1000} onIdle={onIdle}></IdleTimer>
        <div className='content'>
       
        <Switch>
          
          <Protegerotas path="/test/home/Comprar-Token" exact component={ComprarToken} />
      
                           
        </Switch>
    
        </div>
        
        </div>
     </Router>
    
    )
}
export default RHome
